import { reducerFor } from '../common/redux-crud-reducers'

const handleConfigState = reducerFor('config', null)

export default handleConfigState
